import { useGetInvoicesSummaryReport } from '../../../../hooks/requests/use-get-invoices-summary-report';
import { UseQueryOptions } from 'react-query';
import { GetInvoicesSummaryReportResponse } from '@vy/api-definition';

export function useReportsInvoicesSummary(options?: UseQueryOptions<GetInvoicesSummaryReportResponse>) {
  const { data, isLoading } = useGetInvoicesSummaryReport(options);

  return {
    data: {
      invoicesSummary: data?.invoicesSummary?.revenueByBillingStatus,
      comparisons: data?.invoicesSummary?.comparisons,
      countsByBillingStatus: data?.invoicesSummary?.countsByBillingStatus,
    },
    isLoading,
  };
}
